var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoIco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5771 36.6077L16.5771 -1.52588e-05L20.0307 -1.54097e-05L20.0307 36.6077L16.5771 36.6077Z",
    fill: "#D7922A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13965 30.0212L30.0252 4.1357L32.4672 6.57773L6.58168 32.4633L4.13965 30.0212Z",
    fill: "#D7922A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5769H36.6077V20.0305H0V16.5769Z",
    fill: "#D7922A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58203 4.13599L32.4676 30.0215L30.0255 32.4636L4.14 6.57802L6.58203 4.13599Z",
    fill: "#D7922A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco3);
export default __webpack_public_path__ + "static/media/decoIco3.00b7c5e87202c610083f8552f069598e.svg";
export { ForwardRef as ReactComponent };